import { Component, Input, ViewChild } from '@angular/core';

import { IconPipe } from '../../pipes/icon/icon';
import { CategoriesProvider } from '../../providers/categories/categories';

/**
 * Generated class for the MysportIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'mysport-icon',
  templateUrl: 'mysport-icon.html'
})
export class MysportIconComponent {

  @Input("cid")
  cid: number;

  src: string;
  @ViewChild("ref")
  ref;
  prevCid: number;
  constructor(private iconPipe: IconPipe, private catService: CategoriesProvider) {

  }
  ngOnChanges() {
    if (this.prevCid === this.cid) return;
    this.prevCid = this.cid;
    new Promise(async (resolve) => {
      this.src = await this.iconPipe.transform(this.cid + "");

      this.ref.nativeElement.style = "-webkit-mask-image:url('" + this.src + "')";
    })

  }

}



// WEBPACK FOOTER //
// /src/components/mysport-icon/mysport-icon.ts